import { useContext } from "react"
import { PopUpContext } from "../layout/Root"
import OrderDish from "./OrderDish"

const oneLinerStyle = { textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }

export default function DishCard({ d, type, index }) {
   const [, setPopUp] = useContext(PopUpContext)

   function orderDish() {
      setPopUp({ title: 'order dish', component: <OrderDish d={d} /> })
   }

   return (
      <div className='card slide-in-left' style={{ animationDelay: `${index * 2}00ms` }}>
         <img className="card-img-top" height={200} src={d.img} alt={d.title} style={{ objectFit: 'cover', aspectRatio: '4/3' }} />
         <div className="card-body text-center">
            <h5 className="card-title  text-uppercase mb-4" style={oneLinerStyle}>{d.title}</h5>
            {/* <span className='badge bg-primary rounded-pill mb-2 p-2'> {d.calories} {' '} calories</span> */}
            <p className="card-text " style={oneLinerStyle}>{d.desc}</p>
            {type === 'client' && <button onClick={orderDish} href="#" className="btn btn-primary">Order (${d.price})</button>}
         </div>
      </div>
   )
}
